<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="translationTooltip" class="card-loca-wrap">
    <div v-tooltip="translationTooltip" class="icon-wrapper">
      <div class="supra-icon" :class="types.indexOf('supramunicipal') !== -1 && 'selected'">
        <div class="muni-icon" :class="types.indexOf('municipi') !== -1 && 'selected'">
          <div class="disc-icon" :class="types.indexOf('districte') !== -1 && 'selected'">
            <div class="barr-icon" :class="types.indexOf('barri') !== -1 && 'selected'">
              <div class="aeb-icon" :class="types.indexOf('area estadistica basica') !== -1 && 'selected'">
                <div class="cens-icon" :class="types.indexOf('seccio censal') !== -1 && 'selected'" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { t } from '@/i18n'
/**
 * Display diferent icon logo depending on type
 */
export default {
  name: 'ItemLocaIcon',
  props: {
    /**
     * Sets the types of the icon
     * @values supramunicipal, municipi, districte, barri, area estadistica basica, seccio censal
     */
    types: {
      type: Array,
    },
  },
  computed: {
    translationTooltip() {
      let availableTypes = [
        'supramunicipal',
        'municipi',
        'districte',
        'barri',
        'area estadistica basica',
        'seccio censal',
      ]
      let filteredTypes = this.types && availableTypes.filter(el => this.types.indexOf(el) !== -1)
      let count = filteredTypes && filteredTypes.length
      let transString = ''
      if (filteredTypes && count > 1) {
        filteredTypes.forEach((element, i) => {
          if (i === 0) transString = t(element.replace(/ /g, '_'))
          else if (i < count - 1) transString += ', ' + t(element.replace(/ /g, '_'))
          else transString += ' ' + t('and') + ' ' + t(element.replace(/ /g, '_'))
        })
      } else {
        transString = filteredTypes && filteredTypes[0] ? t(filteredTypes[0]) : undefined
      }
      return transString
    },
  },
}
</script>

<style lang="stylus" scoped>
.card-loca-wrap
  display: flex
  margin-left: vw(10px)
  padding-left: vw(10px)
  border-left: 1px solid $bcn-other-grey

  .icon-wrapper
    display: flex
    justify-content: center
    align-items: center
    width: vw(30px)
    height: vw(30px)
    padding: vw(2px)
    border-radius: 50%
    background-color: $light-grey

    .supra-icon
      display: flex
      justify-content: center
      align-items: center
      width: 100%
      height: 100%
      padding: vw(2px)
      border-radius: 50%

      &.selected
        box-shadow: 0 0 0 vw(3px) $icon-blue inset

      .muni-icon
        display: flex
        justify-content: center
        align-items: center
        width: 100%
        height: 100%
        padding: vw(2px)
        border-radius: 50%

        &.selected
          box-shadow: 0 0 0 vw(3px) $icon-blue inset

        .disc-icon
          display: flex
          justify-content: center
          align-items: center
          width: 100%
          height: 100%
          padding: vw(2px)
          border-radius: 50%

          &.selected
            box-shadow: 0 0 0 vw(3px) $icon-blue inset

          .barr-icon
            display: flex
            justify-content: center
            align-items: center
            width: 100%
            height: 100%
            padding: vw(2px)
            border-radius: 50%

            &.selected
              box-shadow: 0 0 0 vw(3px) $icon-blue inset

            .aeb-icon
              display: flex
              justify-content: center
              align-items: center
              width: 100%
              height: 100%
              padding: vw(2px)
              border-radius: 50%

              &.selected
                box-shadow: 0 0 0 vw(3px) $icon-blue inset

              .cens-icon
                display: flex
                justify-content: center
                align-items: center
                width: 100%
                height: 100%
                border-radius: 50%

                &.selected
                  box-shadow: 0 0 0 vw(3px) $icon-blue inset
                  background-color: $icon-blue
</style>